import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Button from "@mui/material/Button";
import PaymentIcon from "@mui/icons-material/Payment";
import Header from "../../components/common/header/Header";
import Footer from "../../components/common/footer/Footer";
import "./admin-home.css";

function GenerateTokenPage() {
  const [copyToken, setCopyToken] = useState(false);
  const [desktopToken, setDesktopToken] = useState("");
  const [currentSessionConfig, setCurrentSessionConfig] = useState({
    interViewTime: 0,
    skills: [],
    interviewType: "",
    jobTitle: "",
    jobDescription: "",
  });
  const navigate = useNavigate();

  React.useEffect(() => {
    const getDesktopToken = localStorage.getItem("desktopToken");
    if (getDesktopToken) {
      setDesktopToken(getDesktopToken);
      let tokenParamDetails = localStorage.getItem("tokenParams");
      if (tokenParamDetails) {
        tokenParamDetails = JSON.parse(tokenParamDetails);
        setCurrentSessionConfig({
          interViewTime: tokenParamDetails?.interViewTime || 0,
          skills: tokenParamDetails?.skills || [],
          interviewType: tokenParamDetails?.interView || "",
          jobTitle: tokenParamDetails?.jobTitle || "",
          jobDescription: tokenParamDetails?.jobDescription || "",
        });
      }
      // localStorage.removeItem("tokenParams");
      // localStorage.removeItem("desktopToken");
    } else {
      navigate("/home");
    }
  }, []);

  return (
    <>
      <Header />
      <div className="admin-home-container my-5">
        <div className="speech-to-text">
          <button
            className="make-payment-button"
            onClick={() => {
              window.open(
                "/checkout/9b1deb4d-9bdd-3b7d-4bad-2b0d7b3dcb8d",
                "_blank"
              );
            }}
            title="Purchase more time"
          >
            <PaymentIcon style={{ marginRight: "5px", fontSize: "16px" }} />
            Pay
          </button>
          <div className="flex-container">
            <div className="answer-container">
              <div className="section-header">
                <h3>Interview Context</h3>
              </div>
            </div>
            <div className="question-container">
              <div className="context-details">
                <p className="text-dark">
                  <strong>Job Title:</strong>{" "}
                  {currentSessionConfig?.jobTitle || "N/A"}
                </p>
                <p className="text-dark">
                  <strong>Interview Time:</strong>{" "}
                  {currentSessionConfig?.interViewTime || "0"}{" "}
                  {currentSessionConfig?.interViewTime > 1
                    ? "Minutes"
                    : "Minute"}
                </p>
                <p className="text-dark">
                  <strong>Skills:</strong>{" "}
                  {currentSessionConfig?.skills || "N/A"}
                </p>
                {currentSessionConfig?.jobDescription && (
                  <p className="text-dark">
                    <strong>Description:</strong>{" "}
                    {currentSessionConfig.jobDescription}
                  </p>
                )}
                {desktopToken && (
                  <>
                    <div className="row">
                      <div className="col">
                        <strong className="text-dark">Token:</strong>
                      </div>
                      <div className="col-2" style={{ textAlign: "right" }}>
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() => {
                            navigator.clipboard.writeText(desktopToken);
                            setCopyToken(true);
                            setTimeout(() => setCopyToken(false), 5000);
                          }}
                          className="copy-button"
                        >
                          {copyToken && (
                            <>
                              <CheckIcon style={{ marginRight: 4 }} /> Copyd!
                            </>
                          )}
                          {!copyToken && (
                            <>
                              <ContentCopyIcon style={{ marginRight: 4 }} />{" "}
                              Copy
                            </>
                          )}
                        </Button>
                      </div>
                    </div>
                    <code>{desktopToken}</code>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default GenerateTokenPage;
